import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function table(theme: Theme): ComponentStyle {
  return {
    componentName: 'table',
    baseStyle: {
      border: 0,
      paddingTop: theme.space.s,
      paddingBottom: theme.space.s,
      background: theme.colors.onSurface,
      borderRadius: theme.sizes['-2']
    },
    variants: {
      insideCard: {
        padding: 0
      }
    }
  };
}
